import React from "react";
import { useNavigate } from "react-router-dom";
import { BadgeCheck } from "lucide-react";

const PostHeader = ({ post, onShowOptions, feedType, hideEngagement }) => {
  const navigate = useNavigate();

  const getProfilePicture = () => {
    const profilePic = post.profilePicture;
    if (profilePic && typeof profilePic === "object") {
      return profilePic.small || profilePic.medium;
    }
    return null;
  };

  const getInitials = (name) => {
    if (!name) return "";
    const words = name.trim().split(/\s+/);
    if (words.length === 1) {
      return words[0].charAt(0).toUpperCase();
    }
    return (words[0].charAt(0) + words[1].charAt(0)).toUpperCase();
  };

  // ✅ NEW: Handle profile click
  const handleProfileClick = () => {
    if (post.author) {
      navigate(`/${post.author}`);
    }
  };

  const profilePictureUrl = getProfilePicture();

  return (
    <div className="flex items-center justify-between px-3 py-3 w-full bg-white">
      {/* Left Section: Avatar + Identity */}
      {/* ✅ UPDATED: Added onClick and cursor-pointer to entire section */}
      <div 
        className="flex items-center gap-3 cursor-pointer"
        onClick={handleProfileClick}
      >
        {/* Profile Picture - Increased to 40px (w-10) */}
        <div className="flex-shrink-0">
          {profilePictureUrl ? (
            <img
              src={profilePictureUrl}
              alt={post.name}
              className="w-12 h-12 rounded-full object-cover border-[0.5px] border-gray-200 hover:opacity-80 transition-opacity"
            />
          ) : (
            <div className="w-10 h-10 rounded-full bg-gradient-to-br from-slate-100 to-slate-200 flex items-center justify-center overflow-hidden hover:opacity-80 transition-opacity">
              {post.name ? (
                <span className="text-slate-600 font-semibold text-base">
                  {getInitials(post.name)}
                </span>
              ) : (
                <svg
                  className="w-full h-full text-slate-400"
                  viewBox="0 0 100 100"
                  fill="currentColor"
                >
                  <circle cx="50" cy="35" r="18" />
                  <path d="M50 58 C 25 58, 10 65, 10 100 L 90 100 C 90 65, 75 58, 50 58 Z" />
                </svg>
              )}
            </div>
          )}
        </div>

        {/* Text Details */}
        <div className="flex flex-col justify-center">
          <div className="flex items-center gap-1">
            {/* ✅ UPDATED: Author name now has hover effect */}
            <span className="text-[14px] font-bold text-gray-900 hover:text-gray-500 transition-colors leading-none">
              {post.author}
            </span>
            {post.verified && (
              <BadgeCheck className="w-[18px] h-[18px] fill-[#b0d284] stroke-white flex-shrink-0" />
            )}
          </div>

          {post.type && (
            <span className="text-[12px] text-gray-500 font-normal mt-0.5">
              {post.type}
            </span>
          )}
        </div>
      </div>

      {/* Right Section: Options Button */}
      {/* <button
        onClick={() => onShowOptions(post.id)}
        className="p-2 active:opacity-30 transition-opacity flex items-center justify-center"
      >
        <svg
          aria-label="More options"
          className="text-gray-800"
          fill="currentColor"
          height="24"
          role="img"
          viewBox="0 0 24 24"
          width="24"
        >
          <circle cx="12" cy="12" r="1.5"></circle>
          <circle cx="6" cy="12" r="1.5"></circle>
          <circle cx="18" cy="12" r="1.5"></circle>
        </svg>
      </button> */}
      {!hideEngagement && (
        <button
          onClick={() => onShowOptions(post.id)}
          className="p-2 active:opacity-30 transition-opacity flex items-center justify-center"
        >
          <svg aria-label="More options" role="img" width="24" height="24" viewBox="0 0 24 24">
            <line
              x1="5"
              y1="7"
              x2="19"
              y2="7"
              stroke="#1f2937"
              strokeWidth="2.2"
              strokeLinecap="round"
            />
            <line
              x1="9"
              y1="12"
              x2="15"
              y2="12"
              stroke="#1f2937"
              strokeWidth="2.2"
              strokeLinecap="round"
            />
            <line
              x1="5"
              y1="17"
              x2="19"
              y2="17"
              stroke="#1f2937"
              strokeWidth="2.2"
              strokeLinecap="round"
            />
          </svg>
        </button>
      )}
    </div>
  );
};

export default PostHeader;